var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"rotate(180,10.5,10.5)"},[React.createElement("path",{"d":"M19.2682 10.2776L3.30078 10.2773","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M10.0869 19.46L19.2793 10.2676L10.0869 1.07519","strokeWidth":"2","key":1})]));
}

ArrowLeftInline.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
